import React from 'react';
import { Input as WixInput } from '@wix/design-system';

const Input = (config) => {
  return <WixInput {...config} />;
};

export default Input;
